import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SOuterContainer = styled.div`
  margin: 0 var(--p-content);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${BREAKPOINTS.LG.min} {
    margin-top: 3rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 1rem;
    flex-direction: column;
  }
`

export const SLeftContainer = styled.div<{ isDragActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 45%;
  position: relative;

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
    order: 1;
  }

  outline: none;
  border: 2px solid transparent;
  ${({ isDragActive }) =>
    isDragActive &&
    css`
      box-sizing: initial;
      border: 2px dashed var(--c-blue300);
      background-color: var(--c-blue100);
    `}
`

export const SContentBox = styled.div`
  width: 100%;
  position: relative;
  padding: 1.5rem 4rem 1rem 0;
  margin-top: 2rem;
  margin-bottom: 2rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: 0;
    left: var(--p-button);
    right: -19px;
    bottom: 0;
    max-width: 100%;
    box-sizing: content-box;
  }

  @media ${BREAKPOINTS.LG.max} {
    padding: 20px 10px 20px 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 0 20px 0;

    &:before {
      top: -1rem;
      bottom: -30%;
      right: -20%;
    }
  }
`

export const SDescription = styled(Text)`
  margin-top: 1.5rem;

  @media ${BREAKPOINTS.MD.min} {
    max-width: 25rem;
  }
`

export const SDragDropTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: -4rem;
`

export const SImg = styled.img`
  width: 72px;
  height: 72px;
  margin-bottom: ${pxToRem(20)}rem;
  opacity: 0.5;
`

export const SLicenseContainer = styled.div<{ isAbsolute?: boolean }>`
  display: flex;
  align-items: center;

  & > span {
    margin-right: 0.5rem;
  }

  ${({ isAbsolute }) =>
    isAbsolute
      ? css`
          @media ${BREAKPOINTS.LG.max} {
            position: absolute;
            top: 103%;
            bottom: 0;
            right: -3.5%;
          }
        `
      : css`
          margin-top: 1rem;
          justify-content: center;
        `}
`

export const ShareItemsContainer = styled.div`
  width: calc(100% + 2 * var(--p-button));

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`

export const SRightContainer = styled.div<{ isUploading?: boolean }>`
  width: 47%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > div {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-position: center 15%;
  }

  @media ${BREAKPOINTS.MD.max} {
    order: 2;
    width: 100%;
    margin-bottom: 1rem;
  }
`

export const SUploadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 24rem;
  padding: 24px;

  background-color: var(--c-gray300);
  border: 2px solid var(--c-blue100);

  & > div {
    margin-bottom: 1rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    min-height: auto;
  }
`

export const SInstructiveText = styled(Text)`
  margin-left: calc(2 * var(--p-button));
  color: var(--c-gray500);
  cursor: default;
  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`

export const mediaModalCss = css`
  overflow: hidden;
  @media ${BREAKPOINTS.MD.min} {
    max-width: 64rem;
    max-height: 100vh;
    align-self: center;
  }
`
